<template>
  <ul class="nav nav-pills content-nav">
    <li
      v-for="tab in visibleTabs"
      :key="tab.key"
      :class="value === tab.key && 'active'"
      @click="$emit('input', tab.key)"
    >
      <a data-toggle="tab">{{ tab.label }}</a>
    </li>
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'TabNav',

  props: {
    value: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
  },

  computed: {
    visibleTabs() {
      return this.tabs.filter(tab => tab.show !== false);
    },
  },
};
</script>

<style scoped>
li a {
  cursor: pointer;
}
</style>
